'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _autosize = require('autosize');var _autosize2 = _interopRequireDefault(_autosize);

var _convertStringToHTML = require('../../utils/convertStringToHTML');var _convertStringToHTML2 = _interopRequireDefault(_convertStringToHTML);

var _NotePropertyInput = require('./NotePropertyInput.scss');var styles = _interopRequireWildcard(_NotePropertyInput);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

NotePropertyInput = function (_Component) {_inherits(NotePropertyInput, _Component);
  function NotePropertyInput(props) {_classCallCheck(this, NotePropertyInput);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



















    handleDelete = function (evt) {
      _this.props.openNote(evt);
      _this.props.addNote();
    };_this.

    closeNote = function (evt) {return _this.props.openNote(evt);};_this.

    handleClick = function (evt) {var
      value = _this.input.value;

      _this.props.addNote(value);
      var updatedData = (0, _convertStringToHTML2.default)(value);

      _this.setState(Object.assign({},
      updatedData, {
        inputIsActive: false }));


      _this.props.openNote(evt);
    };_this.state = Object.assign({ inputIsActive: props.inputIsActive || false, htmlContent: null, content: null }, (0, _convertStringToHTML2.default)(_this.props.value));return _this;}NotePropertyInput.prototype.componentDidMount = function componentDidMount() {this.input.focus();};NotePropertyInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var value = _ref.value;if (!this.props.value && value) {this.setState(Object.assign({}, (0, _convertStringToHTML2.default)(value)));}};NotePropertyInput.prototype.

  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.noteWrapper, this.props.className) },
        _react2.default.createElement('div', { className: styles.textareaWrapper },
          _react2.default.createElement('textarea', {
            ref: function ref(input) {_this2.input = input;},
            name: 'note',
            defaultValue: this.state.content,
            placeholder: this.props.placeholderTextArea })),


        _react2.default.createElement('div', null,
          _react2.default.createElement('div', null,
            _react2.default.createElement('p', {
                className: styles.delete,
                onClick: this.handleDelete },

              _react2.default.createElement('i', { className: 'icon icon-delete-property' })),

            _react2.default.createElement('p', {
                className: styles.save,
                onClick: this.handleClick },

              this.props.translate('save'))),


          this.props.isMobile &&
          _react2.default.createElement('p', {
              className: styles.save,
              onClick: this.closeNote },

            this.props.translate('close')))));





  };return NotePropertyInput;}(_react.Component);exports.default = NotePropertyInput;


NotePropertyInput.propTypes = {
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string,
  placeholderTextArea: _propTypes2.default.string,
  inputIsActive: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  handleClick: _propTypes2.default.func,
  openNote: _propTypes2.default.func,
  addNote: _propTypes2.default.func,
  translate: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/NotesProperty/NotePropertyInput.js
// module id = 2752
// module chunks = 0